import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Polygon } from '../../polygon/polygon';

interface Data {
  citiesCount?: number;
  msg?: string;
  step?: string;
  citiesOrStreetsMsg?: string;
}

@Component({
  selector: 'app-delete-dialog',
  templateUrl: './polygon-success-dialog.html',
  styleUrls: ['./polygon-success-dialog.scss'],
  standalone: false,
})
export class PolygonSuccessDialog implements OnInit {
  @Output() onDeliveryMethod = new EventEmitter<string>();
  @Output() onGetCitiesList = new EventEmitter<any>();
  citiesCount?: number;
  citiesOrStreetsMsg?: string;
  msg?: string;
  step: string;

  constructor(
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<Polygon>,
    @Inject(MAT_DIALOG_DATA) public data: Data,
  ) {}

  ngOnInit() {
    this.citiesCount = this.data.citiesCount;
    this.msg = this.data?.msg;
    this.step = this.data?.step;
    this.citiesOrStreetsMsg = this.data?.citiesOrStreetsMsg;
  }

  onClose(): void {
    this.dialogRef.close();
  }

  getCitiesList(event): void {
    this.dialogRef.close();
    this.onGetCitiesList.emit();
  }

  onDeliveryMethodDiscard(): any {
    this.onDeliveryMethod.emit('close');
    this.dialogRef.close();
  }

  onDeliveryMethodRelease(): any {
    this.onDeliveryMethod.emit('open');
    this.dialogRef.close();
  }
}
